import 'simplebar';
import HandyCollapse from "handy-collapse";
const utilities = () => {
    handleMobileMenu();
    handleMainMenu();
    const myAccrodion = new HandyCollapse();
}

const mainMenu = document.querySelector('.main-menu');

const handleMobileMenu = () => {
    if (document.querySelector('.burger')) {
        const mobileMenu = document.querySelector('.mobile-menu');
        const hamburger = mobileMenu.querySelector('.burger');
        const logo = mobileMenu.querySelector('.mobile-menu__logo');
        const menuArr = [mainMenu, mobileMenu];

        window.addEventListener('resize', () => {
            hamburger.classList.remove('is-active');
            mainMenu.classList.remove('is-active');
        })

        const toggleMenu = target => {
            target.style.pointerEvents = 'none';

            setTimeout(() => {
                target.style.pointerEvents = 'all';
            }, 400);

            hamburger.classList.toggle('is-active');
            mainMenu.classList.toggle('is-active');
        };

        menuArr.forEach(menu => {
            menu.addEventListener('click', e => {
                if (e.target === logo && !mainMenu.classList.contains('is-active')) return;

                if (e.target !== menu) {
                    toggleMenu(e.target);
                };
            });
        });
    };
}

const handleMainMenu = () => {
    if (mainMenu && document.body.id === 'home') {
        document.addEventListener('scroll', e => {
            if (window.scrollY > 60) {
                mainMenu.classList.add('is-scrolled');
            } else {
                mainMenu.classList.remove('is-scrolled');
            }
        });
    } else {
        mainMenu.classList.add('is-scrolled');
    };
}

export default utilities;